import { useQuery } from "@tanstack/react-query";

import { getFootprintingDairyPrimaryDataByYear } from "services";

import { getActiveToken, getEnvironment, shouldRetryQueryError, useGetCarbonProgramByFarmId, useUserContext } from "utils";

import { FOOTPRINTING_DAIRY_PRIMARY_DATA } from "consts";

export const useGetFootprintingDairyPrimaryData = (farmId: string, year: number) => {
  const isAdmin = getEnvironment().admin;
  const { user } = useUserContext();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const token = getActiveToken();

  return useQuery({
    queryKey: [FOOTPRINTING_DAIRY_PRIMARY_DATA, farmId, year, isAdmin],
    queryFn: () => getFootprintingDairyPrimaryDataByYear(farmId ?? "", year),
    enabled: !!farmId && !!year && !!user && !!token && !!carbonProgram?.platformFeatures?.footprinting?.enabled,
    gcTime: 60000,
    retry: shouldRetryQueryError(),
  });
};
